import { render, staticRenderFns } from "./CustomerCategorySlimList.vue?vue&type=template&id=54dfa8b6"
import script from "./CustomerCategorySlimList.vue?vue&type=script&lang=js"
export * from "./CustomerCategorySlimList.vue?vue&type=script&lang=js"
import style0 from "./CustomerCategorySlimList.vue?vue&type=style&index=0&id=54dfa8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports